// Fade in Up
const hideFadeUpTargets = document.querySelectorAll('.hide-fade-up');

const hideFadeUpObserver = new IntersectionObserver((entries) => {
	entries.forEach((entry) => {
		if (entry.isIntersecting) {
			entry.target.classList.add('show-fade-up');
		} else {
			entry.target.classList.remove('show-fade-up');
		}
		if (entry.isIntersecting) {
			entry.target.classList.add('show-fade-ltr');
		} else {
			entry.target.classList.remove('show-fade-ltr');
		}
	});
});
hideFadeUpTargets.forEach((el) => hideFadeUpObserver.observe(el));

// Fade in Left to Right
const fadeLTRTargets = document.querySelectorAll('.hide-fade-ltr');
const fadeLTRObserver = new IntersectionObserver((entries) => {
	entries.forEach((entry) => {
		if (entry.isIntersecting) {
			entry.target.classList.add('show-fade-ltr');
		} else {
			entry.target.classList.remove('show-fade-ltr');
		}
	});
});
fadeLTRTargets.forEach((el) => fadeLTRObserver.observe(el));

// Fade in Right to Left
const fadeRTLTargets = document.querySelectorAll('.hide-fade-rtl');
const fadeRTLObserver = new IntersectionObserver((entries) => {
	entries.forEach((entry) => {
		if (entry.isIntersecting) {
			entry.target.classList.add('show-fade-rtl');
		} else {
			entry.target.classList.remove('show-fade-rtl');
		}
	});
});
fadeRTLTargets.forEach((el) => fadeRTLObserver.observe(el));

// Fade in
const fadeInTargets = document.querySelectorAll('.hide-fade-in');
const fadeInObserver = new IntersectionObserver((entries) => {
	entries.forEach((entry) => {
		if (entry.isIntersecting) {
			entry.target.classList.add('show-fade-in');
		} else {
			entry.target.classList.remove('show-fade-in');
		}
	});
});
fadeInTargets.forEach((el) => fadeInObserver.observe(el));

// Grow in
const growInTargets = document.querySelectorAll('.hide-grow-in');
const growInObserver = new IntersectionObserver((entries) => {
	entries.forEach((entry) => {
		if (entry.isIntersecting) {
			entry.target.classList.add('show-grow-in');
		} else {
			entry.target.classList.remove('show-grow-in');
		}
	});
});
growInTargets.forEach((el) => growInObserver.observe(el));

// Animate once
const animateOnceTargets = document.querySelectorAll('.animate-once');
const animateOnceObserver = new IntersectionObserver((entries) => {
	entries.forEach((entry) => {
		if (entry.isIntersecting) {
			entry.target.classList.add('animate');
			animateOnceObserver.unobserve(entry.target);
		}
	});
});
animateOnceTargets.forEach((el) => animateOnceObserver.observe(el));
